import {svgIconWrapper} from '../svg-icon-wrapper';

import CaretSolidDown from './caret-solid-down-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CaretSolidDown {...validProps} />;
}

SvgComponent.iconName = 'caretSolidDown';

export const CaretSolidDownIcon = svgIconWrapper(SvgComponent);
